
import React, { useState, useEffect } from "react";
import "antd/dist/antd.min.css";
import BackButton from "../../helpers/BackButton";
import { Breadcrumb, Layout, Menu, Typography, DatePicker } from "antd";
import { Space, Table, Tag, Button } from "antd";
import TokenService from "../../../services/token.service";
import PageWrapper from "../../helpers/PageWrapper";
import streamService from '../../../services/streamService';
import { Input, Form, Select, InputNumber, message } from 'antd';
// import { LessonDtoRequest } from '../../interfaces/LessonDtoRequest';
import authAxios from "../../../services/api";
import { useParams } from 'react-router';
const { Title } = Typography;
const styles = { width: '800px', margin: '0 auto' };

const { Option } = Select;
const StreamCreatePage = () => {
    const [teachers, setTeachers] = useState([]);
    const [groups, setGroups] = useState([]);
    const [disciplines, setDisciplines] = useState([]);
    const [selectedName, setSelectedName] = useState();
    const [selectedTeacherId, setSelectedTeacherId] = useState();
    const [selectedGroupId, setSelectedGroupId] = useState();
    const [selectedDisciplineId, setSelectedDisciplineId] = useState();



  useEffect(() => {
    
    authAxios.get(`http://85.159.27.198:8080/abitur/api/v1/teacher`,{
      headers: {
          'Authorization': 'Bearer ' + TokenService.getLocalAccessToken(),
      }
  })
      .then((response) => {
        setTeachers(response.data);
        
      })
      .catch((err) => {
        console.log(err.message);
      });

  }, []);
  const mergeArraysTeacher = (arr1) => {
    return arr1.map((teacher) => {

      return teacher;
    })
  };

  const teacherArrays = mergeArraysTeacher(teachers)
//   console.log(teacherArrays)
  useEffect(() => {
    
    authAxios.get(`http://85.159.27.198:8080/abitur/api/v1/group`,{
      
      headers: {
          'Authorization': 'Bearer ' + TokenService.getLocalAccessToken(),
      }
  })
      .then((response) => {
        setGroups(response.data);
        
      })
      .catch((err) => {
        console.log(err.message);
      });

  }, []);
  const mergeArraysGroup = (arr1) => {
    return arr1.map((group) => {

      return group;
    })
  };

  const groupArrays = mergeArraysGroup(groups)
//   console.log(groupArrays)

  useEffect(() => {
    
    authAxios.get(`http://85.159.27.198:8080/abitur/api/v1/discipline`, {
      headers: {
          'Authorization': 'Bearer ' + TokenService.getLocalAccessToken(),
      }
  })
      .then((response) =>  {
        setDisciplines(response.data);
        
      })
      .catch((err) => {
        console.log(err.message);
      });

  }, []);
  const mergeArraysDiscipline = (arr1) => {
    return arr1.map((discipline) => {

      return discipline;
    })
  };

  const disciplineArrays = mergeArraysDiscipline(disciplines)
//   console.log(disciplineArrays)

  const onNameChange = (e) => {
    setSelectedName(e.target.value)
    // console.log(`selected name ${e.target.value}`);
  };

  const handleOnChangeDiscipline = (value) => {
    setSelectedDisciplineId(value)
    
  };
  const handleOnChangeGroup = (value) => {
    setSelectedGroupId(value)
    
  };
  const handleOnChangeTeacher = (value) => {
    setSelectedTeacherId(value)
    
  };
  const name1 = selectedName
 
  let teacherId = selectedTeacherId

  let groupId = selectedGroupId
  
  let disciplineId = selectedDisciplineId
  

  const handleSubmit = () => {
    
    const lesson = {
        name: name1,
        groupId: groupId,
        teacherId: teacherId,
        disciplineId: disciplineId,
      };

      authAxios.post(`http://85.159.27.198:8080/abitur/api/v1/streams/create`, lesson,  {
      headers: {
        'Authorization': 'Bearer ' + TokenService.getLocalAccessToken()
      }
    })
      .then(res => {
        console.log(res);
        console.log(res.data);
        // window.location.reload();
      })
      message.success('Новый поток добавлен', 5);
  }

 
    return (
      <PageWrapper>
        
        <Typography.Title level={1}>Создать поток</Typography.Title>
        <section>
        <Space size={20} direction={'vertical'}>
        <Input placeholder="Наименование потока" name="name"
            value={selectedName}
            onChange={onNameChange} />
        <Space size={20} direction={'vertical'}></Space>
        <Select
    
    placeholder="Выберите преподавателя"
    // selectedOption={selectedTeacherId}
    //   onSelect={onSelect}
    style={{ width:  400 }}
    //   optionFilterProp="children"
    //   allowClear
    //   onClear={onClear}
    value = {selectedTeacherId}
    onChange={handleOnChangeTeacher}
    >
      {teacherArrays.map((option) => (
        <Option key={option.id} value={option.id}>
          {option.surname} {option.name} {option.patronymic}
        </Option>
      ))}
    </Select>

    <Select
    
    placeholder="Выберите группу"
    // selectedOption={selectedGroupId}
    //   onSelect={onSelect}
    style={{ width:  400 }}
    //   optionFilterProp="children"
    //   allowClear
    //   onClear={onClear}
    value = {selectedGroupId}
    onChange={handleOnChangeGroup}
    >
      {groupArrays.map((option) => (
        <Option key={option.id} value={option.id}>
          {option.surname} {option.name} {option.patronymic}
        </Option>
      ))}
    </Select>

    <Select
    style={{ width:  400 }}
    
    placeholder="Выберите Дисциплину"
    value={selectedDisciplineId}
    
    onChange={handleOnChangeDiscipline}
    //   optionFilterProp="children"
    //   allowClear
    //   onClear={onClear}
    
    >
      {disciplineArrays.map((option) => (
        <Option key={option.id} value={option.id}>
          {option.surname} {option.name} {option.patronymic}
        </Option>
      ))}
    </Select>
  
        </Space>
        <br />
        <br />
        <Space size={20}>
          <Button type={'default'} onClick={handleSubmit}>
            Создать поток
          </Button>

          
        </Space>
      </section>
      </PageWrapper>



    )
  }


export default StreamCreatePage;